<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { RouterView } from 'vue-router'
import WhatsAppButton from '@/components/common/WhatsAppButton.vue'
import { useSiteSettingsStore } from '@/stores/siteSettings'
import { useSiteHead } from '@/composables/useSiteHead'

const settingsStore = useSiteSettingsStore()
const { applyHead, injectAnalytics } = useSiteHead()

onMounted(async () => {
  await settingsStore.load()
  applyHead()
  injectAnalytics(settingsStore.values.google_analytics_id)
})

watch(() => settingsStore.values, () => applyHead(), { deep: true })
</script>

<template>
  <div id="app" class="min-h-screen flex flex-col">
    <RouterView />
    <WhatsAppButton />
  </div>
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
